//creates a map when the page loads
ht.declare('div.createMap', function () {
  loadGoogleMaps(this, function () {
    var opts = $(this).metadata().mapOpts;
    var map = new google.maps.Map(this, ht.setMapDefaults());
    ht.buildMultiMarkers(opts, map);
  });
});
